<template>
    <div>
       系统菜单
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
